<div class="picker-dialog">
  <div class="picker-header">
    <div class="picker-title">
      <mat-icon aria-hidden="true">folder_open</mat-icon>
      <h2>{{ 'PROJECT_PICKER.TITLE' | translate }}</h2>
    </div>
    <button type="button" class="close-btn" (click)="cancel()" [attr.aria-label]="'COMMON.CANCEL' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (data.currentProjectName) {
    <p class="picker-context">
      {{ 'PROJECT_PICKER.CURRENT' | translate }}
      <strong>{{ data.currentProjectName }}</strong>
    </p>
  }

  <div class="picker-search">
    <mat-icon class="search-icon" aria-hidden="true">search</mat-icon>
    <input
      type="text"
      [ngModel]="query()"
      (ngModelChange)="onQueryChange($event)"
      [placeholder]="'PROJECT_PICKER.SEARCH_PLACEHOLDER' | translate"
      autocomplete="off"
      spellcheck="false">
  </div>

  <div class="picker-body">
    @if (loading()) {
      <div class="picker-loading">
        <mat-spinner diameter="28"></mat-spinner>
        <span>{{ 'PROJECT_PICKER.LOADING' | translate }}</span>
      </div>
    } @else if (error()) {
      <div class="picker-error">
        <mat-icon aria-hidden="true">error</mat-icon>
        <span>{{ error() }}</span>
      </div>
    } @else if (hasResults()) {
      <ul class="picker-list">
        @for (project of candidates(); track project.id) {
          <li class="picker-row"
              [class.selected]="selectedId() === project.id"
              (click)="selectProject(project)">
            <div class="picker-thumb">
              @if (project.thumbnailUrl) {
                <img [src]="project.thumbnailUrl" [alt]="displayName(project)" loading="lazy">
              } @else {
                <mat-icon aria-hidden="true">image</mat-icon>
              }
            </div>
            <div class="picker-meta">
              <strong class="picker-name">{{ displayName(project) }}</strong>
              @if (project.lastModificationDate) {
                <span class="picker-date">
                  {{ 'PROJECT_PICKER.LAST_MODIFIED' | translate }}: {{ project.lastModificationDate }}
                </span>
              }
            </div>
            @if (selectedId() === project.id) {
              <mat-icon class="picker-check" aria-hidden="true">check_circle</mat-icon>
            }
          </li>
        }

        @if (hasMore()) {
          <li class="picker-load-more">
            <button type="button"
                    class="load-more-btn"
                    [disabled]="loadingMore()"
                    (click)="loadMore()">
              @if (loadingMore()) {
                <mat-spinner diameter="16"></mat-spinner>
                <span>{{ 'PROJECT_PICKER.LOADING_MORE' | translate }}</span>
              } @else {
                <mat-icon aria-hidden="true">expand_more</mat-icon>
                <span>{{ 'PROJECT_PICKER.LOAD_MORE' | translate }}</span>
              }
            </button>
          </li>
        }
      </ul>

      @if (pagination(); as p) {
        <div class="picker-footer-count">
          {{ 'PROJECT_PICKER.SHOWING_COUNT' | translate:{ from: 1, to: candidates().length, total: p.total } }}
        </div>
      }
    } @else if (isEmptySearch()) {
      <div class="picker-empty">
        <mat-icon aria-hidden="true">folder_off</mat-icon>
        <span>{{ 'PROJECT_PICKER.EMPTY' | translate }}</span>
      </div>
    } @else {
      <div class="picker-empty">
        <mat-icon aria-hidden="true">search_off</mat-icon>
        <span>{{ 'PROJECT_PICKER.NO_RESULTS' | translate }}</span>
      </div>
    }
  </div>

  <div class="picker-actions">
    <button type="button" class="btn-cancel" (click)="cancel()">
      {{ 'COMMON.CANCEL' | translate }}
    </button>
    <button type="button"
            class="btn-confirm"
            [disabled]="selectedId() === null"
            (click)="confirm()">
      <mat-icon aria-hidden="true">swap_horiz</mat-icon>
      {{ 'PROJECT_PICKER.CONFIRM_REPLACE' | translate }}
    </button>
  </div>
</div>
